import { fallbackProducts } from "../data/products.js";

const API_URL = import.meta.env.VITE_API_URL || (import.meta.env.DEV ? "http://localhost:5000/api" : "/api");

async function request(path, options = {}) {
  const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;
  const response = await fetch(`${API_URL}${path}`, {
    headers: { ...(isFormData ? {} : { "Content-Type": "application/json" }), ...options.headers },
    credentials: "include",
    ...options,
  });
  const contentType = response.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const payload = isJson ? await response.json().catch(() => ({})) : {};
  if (!response.ok || !isJson) throw new Error(payload.message || "La requête a échoué.");
  return payload;
}

export async function getProducts() {
  try {
    const payload = await request("/products");
    return payload.data;
  } catch {
    return fallbackProducts;
  }
}

export async function getProduct(slug) {
  try {
    const payload = await request(`/products/${encodeURIComponent(slug)}`);
    return payload.data;
  } catch {
    return fallbackProducts.find((product) => product.slug === slug) || null;
  }
}

export function createOrder(order) {
  return request("/orders", { method: "POST", body: JSON.stringify(order) });
}

export function getPaymentConfig() {
  return request("/payments/config");
}

export function createStripeCheckout(order) {
  return request("/payments/checkout", { method: "POST", body: JSON.stringify(order) });
}

export function confirmStripePayment(sessionId) {
  return request("/payments/confirm", { method: "POST", body: JSON.stringify({ sessionId }) });
}

export function sendContactMessage(message) {
  return request("/contact", { method: "POST", body: JSON.stringify(message) });
}

export function subscribeNewsletter(email) {
  return request("/newsletter", { method: "POST", body: JSON.stringify({ email }) });
}

export function adminLogin(credentials) {
  return request("/admin/auth/login", { method: "POST", body: JSON.stringify(credentials) });
}

export function adminLogout() {
  return request("/admin/auth/logout", { method: "POST" });
}

export function getAdminSession() {
  return request("/admin/auth/me");
}

export function adminGet(path) {
  return request(`/admin${path}`);
}

export function adminMutate(path, method, body) {
  return request(`/admin${path}`, { method, ...(body === undefined ? {} : { body: JSON.stringify(body) }) });
}

export function adminUpload(path, file) {
  const body = new FormData();
  body.append("image", file);
  return request(`/admin${path}`, { method: "POST", body });
}
